export default {
    title: 'Volpe Test',
    cover: '/dev-content-files/pdf_cover.jpeg',
    tags: {
        keyword: [
            'Naturaleza',
            'Inclusión',
            'Secundaria',
            'Convivencia',
            'Salidas',
            ' Ciencias Para Niños ',
            'Laboratorio',
            'Ciencias Naturales',
            'Dialogo',
            'Lengua',
        ],
        author: [
            ' Ana Fuhr Stoessel',
            ' María Laura Orlandini',
            ' Joaquín Rodríguez',
            ' Adriana Bertelle',
            ' Carla Inés Maturano',
            ' María Julieta Sánchez',
            ' Alida Abad',
            ' Adriana Casamajor',
            ' Cecilia Acevedo',
            ' María Marta Villalba',
            ' Laura Crespi',
            ' Gustavo Fernández',
            ' Irma Kundt',
            ' Tolosa Arminda C.',
            ' Gabriela De Año',
            ' Inés Ferraco',
            ' Matilde Jáuregui',
            ' Eugenia Labarrieta',
            ' Cristina Iturralde',
            ' Laura Antoniuk',
            ' Fabiola Núñez',
            ' Belén Pozzi',
            ' Viviana Colignon',
            ' Miguel Espinosa',
            ' Cristina Calvo',
            ' Silvia Vargas',
            ' Claudia E. Gutiérrez',
        ],
        category: ['Ciencias Naturales'],
        collection: ['Revista Novedades Educativas'],
    },
    issue_url: 'https://farfalla.localhost/reader/pdf-1-6p-1mb-printf',
    issue_full_url: 'https://farfalla.localhost/reader/pdf-1-6p-1mb-printf?location=1',
    publication_date: '2019',
    twitterUser: 'publicala',
    lang: 'es',
    aboutThisPublication:
        'Opinión » La función de la escuela pública en el siglo XXI. Manuel Jerónimo Becerra Gestión escolar y procesos de mejora » Evaluación y acreditación de saberes a marzo. Vicente Ferreyra » Experiencias de pedagogías villeras en una escuela media. Virginia Saavedra y Jordana Secondi » La dirección escolar transitada como acción facilitadora. Patricia Gaete » El directivo como promotor de la mejora institucional. Rita Tisera » Construyendo oasis en la gestión directiva. Gabriel González y Fernanda Hermida » El proyecto estratégico de supervisión. Sandra Sánchez y Néstor Zorzoli » Cruces posibles para pensar la figura del supervisor en el sistema educativo. Marina Chaves y Romina Gallo » El equipo directivo y la evaluación. Mariana Damonte Convergencia entre disciplinas » Método de proyectos. Antoni Zabala Vidiella y Laia Arnau Belmonte » Crónica de un torneo de técnicas de estudio. Ezequiel Rodríguez y Juliana Tonani » Construyendo puentes entre Arte y Ciencias Sociales. Marcela Riera y Silvina Grinberg » El formato taller en la educación secundaria. Lourdes Massey y Eliana González Formación Docente » El desafío de planificar con otros en el Nivel Superior. L. B. Codazzi y M. E. Spontón Misceláneas » Psicodrama, cuerpo y juego en la formación docente. J. Medina » Agenda » En la red',
};
